import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgMail(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 5.75C2.31917 5.75 1.75 6.31917 1.75 7L1.75 25C1.75 25.6904 2.30964 26.25 3 26.25L29 26.25C29.6904 26.25 30.25 25.6904 30.25 25L30.25 7C30.25 6.30964 29.6904 5.75 29 5.75L3 5.75ZM4.25 9.6951L4.25 23.75L27.75 23.75L27.75 9.69519L16.8075 18.9542C16.3414 19.3486 15.6587 19.3486 15.1926 18.9542L4.25 9.6951ZM25.5876 8.25L6.41247 8.25L16.0001 16.3626L25.5876 8.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgMail);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
